import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import toggle from 'components/common/hoc/toggle'
import { formatPhoneNumber } from 'helpers/phone-number'
import { getGTMServiceData } from 'helpers/googleAnalytic'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import ServiceItem from './ServiceItem'

const mapStateToProps = ({ myStore }) => ({
  myStore,
  storePhoneNumber: myStore ? myStore.phoneNumbers[0] : undefined,
  formattedStorePhoneNumber: myStore ? formatPhoneNumber(myStore.phoneNumbers[0]) : undefined
})

const withServiceGTMData = withProps(({ service }) => ({
  serviceGTMData: getGTMServiceData({ service })
}))

export default compose(
  connect(mapStateToProps, { showStoreLocatorModalInAppointmentMode }),
  withServiceGTMData,
  toggle
)(ServiceItem)
